// @flow @jsx h
import { h, Component } from 'preact'
import { Button } from './common/Button'
import { FocusOnEnter } from '../lib/FocusOnEnter'

type Props = {
  explanation: string,
  onNextClick: Function,
  wasCorrect: boolean
}

export class Explanation extends Component<Props, {}> {
  render() {
    const { explanation, wasCorrect, onNextClick } = this.props

    return (
      <FocusOnEnter>
        <p>
          <strong>{wasCorrect ? 'Riktig! ' : 'Feil! '}</strong>
          {explanation}
        </p>
        <Button onClick={onNextClick}>Neste</Button>
      </FocusOnEnter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/Explanation.js